import React from 'react';
import { theme } from '../styles/theme';
import './TypingIndicator.css';

/**
 * TypingIndicator - Shows when someone is typing
 * Matches Flutter TypingIndicator design
 */
const TypingIndicator = ({ userName }) => {
  return (
    <div className="typing-indicator">
      <div className="typing-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <span className="typing-text">{userName} is typing...</span>
    </div>
  );
};

export default TypingIndicator;

